import { StatusType } from "@datadog/browser-logs";

const env = require(`./config.${process.env['REACT_APP_ENV']}.json`)

const Config = {
    baseURL: env.serverUrl,
    oldServerURL: env.oldServerUrl,
    googleApiKey: "AIzaSyDFbswAUbdZbQFeEy-s2oHc-_-dIcCAZPo",
    defaultSuccessURL: {
        default: "https://www.spetz.app/uk/services/thank-you/",
        AU: "https://www.spetz.app/au/services/thank-you",
        US: "https://www.spetz.app/us/services/thank-you",
        GB: "https://www.spetz.app/uk/services/thank-you/",
        IL: "https://service.spetz.co.il/תודה"
    },
    env:process.env['REACT_APP_ENV'],
    browserLng: window.navigator.language,
    datadog: {
        clientToken: "pub425442774e8d3e2368d5f863e45bd1db",
        site: "datadoghq.eu",
        env: process.env.REACT_APP_ENV || "development",
        service: "Iframe",
        sampleRate: 100,
        forwardConsoleLogs: [],
        forwardErrorsToLogs: true,
        logLevel: StatusType.debug,
    }
}

export default Config;
